import React from 'react';

function Slider() {
  return (
    <div className='slider'>
    </div>
  )
}

export default Slider